// When a till has been left alone.
//
// The rule lives on the client on purpose. A server that locked by the clock
// would lock a till mid-sale whenever a request was slow, and the thing being
// protected is the screen in front of a person, which only that browser can
// see. The server's part is a flag the client sets.

const activityEvents = ['pointerdown', 'keydown', 'touchstart'] as const;

let lastActivity = $state(Date.now());

/** Marks the till as used, now. */
export function noteActivity(): void {
	lastActivity = Date.now();
}

/** How long the till has been alone, in milliseconds. */
export function idleFor(now: number): number {
	return now - lastActivity;
}

/** Starts watching for activity. Returns the function that stops watching. */
export function watchActivity(): () => void {
	if (typeof window === 'undefined') return () => {};
	for (const name of activityEvents) {
		// Capture phase, so a tap is counted even when the handler under it
		// stops the event.
		window.addEventListener(name, noteActivity, { capture: true, passive: true });
	}
	return () => {
		for (const name of activityEvents) {
			window.removeEventListener(name, noteActivity, { capture: true });
		}
	};
}
